module.exports = __webpack_public_path__ + "static/clents_bg-34a98cf72aaf098dad144a44b427a14e.jpg";